export default __webpack_public_path__ + "static/media/VCA_logo_1000x569px_RGB_2.0.152620d5.png";